import * as React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import AppContext from "../context/context";
import { toast } from "react-toastify";
import { forgotPasswordService } from "../../utils/services/loginService.js";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
const isStrongPassword = (password) => {
  const strongPasswordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).*$/;
  return strongPasswordRegex.test(password);
};

function InputField({
  icon,
  placeholder,
  onChange,
  type,
  value,
  endAdornment,
  disableIcon,
  togglePasswordVisibility,
  isPasswordVisible,
  disable,
  defaultIcon,
}) {
  return (
    <div
      style={{
        display: "flex",
        paddingLeft: "0.75rem",
        paddingRight: "0.75rem",
        paddingTop: "0.875rem",
        paddingBottom: "0.875rem",
        marginTop: "1.25rem",
        gap: "1.25rem",
        borderRadius: "0.25rem",
        borderWidth: "1px",
        borderColor: "#ffffff",
        borderStyle: "solid",
        textTransform: "uppercase",
        whiteSpace: "nowrap",
      }}
      // className="flex gap-5 px-3 py-3.5 mt-5 uppercase whitespace-nowrap rounded border border-white border-solid leading-[143%]"
    >
      {disableIcon ? null : defaultIcon ? (
        defaultIcon
      ) : (
        <img
          style={{ aspectRatio: "1 / 1", shrink: "0", width: "1.25rem" }}
          loading="lazy"
          src={icon}
          alt=""
          // className="shrink-0 w-5 aspect-square"
        />
      )}
      <input
        style={{
          flex: "1 1 auto", // flex-auto
          marginTop: "auto", // my-auto
          marginBottom: "auto", // my-auto
          backgroundColor: "transparent", // bg-transparent
          border: "none", // border-none
          outline: "none", // focus:outline-none
          color: disable ? "#9ca3af" : "white", // text-gray-400 or text-white
          borderColor: disable ? "#a3a3a3" : "white", // border-gray-500 or border-white
          borderWidth: "1px",
        }}
        onWheel={(e) => {
          if (type === "number") e.target.blur(); // Blurs the input to prevent scrolling
        }}
        disabled={disable}
        onChange={(e) => onChange(e.target.value)}
        type={type}
        placeholder={placeholder}
        value={value}
        // className={`flex-auto my-auto bg-transparent border-none placeholder-grey focus:outline-none ${
        //   type === 'number' ? 'no-spinner' : ''
        // } ${disable ? 'border-gray-500 text-gray-400' : 'border-white text-white'} border`}
      />
      {togglePasswordVisibility && (
        <div
          style={{ aspectRatio: "1 / 1", width: "1.25rem", cursor: "pointer" }}
          // className="cursor-pointer w-5 aspect-square"
          onClick={togglePasswordVisibility}
        >
          {isPasswordVisible ? (
            <VisibilityOff sx={{ color: "#FFF" }} />
          ) : (
            <Visibility sx={{ color: "#FFF" }} />
          )}
        </div>
      )}
      {endAdornment}
    </div>
  );
}

function ForgotPasswordForm({ setIsAuthenticated }) {
  const navigate = useNavigate();
  const [email, setEmail] = React.useState("");
  const [showOTPForm, setShowOTPForm] = React.useState(false);
  const [otp, setOTP] = React.useState("");
  const [showPasswordForm, setShowPasswordForm] = React.useState(false);
  const [password, setPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [isPasswordVisible, setIsPasswordVisible] = React.useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] =
    React.useState(false);
  const { user, setUser } = React.useContext(AppContext);
  const togglePasswordVisibility = () =>
    setIsPasswordVisible(!isPasswordVisible);
  const toggleConfirmPasswordVisibility = () =>
    setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
  const handleSendOTP = async (e) => {
    e.preventDefault();
    try {
      if (!email) {
        toast.error("Please enter email", { autoClose: 3000 });
        return;
      }
      const response = await forgotPasswordService.sendOTP(email);
      if (response) {
        if (response.password_generation_pending) {
          return navigate(
            `/onboard-login?email=${encodeURIComponent(email)}&otpsent=${true}`,
          );
        }
      }
      setUser(response?.user);
      if (response?.accessToken) {
        setIsAuthenticated(true);
        localStorage.setItem("token", response.accessToken);
        localStorage.setItem("user", JSON.stringify(response.user));
      }
      setShowOTPForm(true);
      toast.success("OTP sent successfully!", { autoClose: 3000 });
    } catch (error) {
      console.error("Error sending OTP:", error);
      toast.error("Failed to send OTP. Please try again.", { autoClose: 3000 });
    }
  };

  const handleSubmitOTP = async (e) => {
    e.preventDefault();
    setShowPasswordForm(false);
    try {
      if (!otp) {
        toast.error("Please enter OTP", { autoClose: 3000 });
        return;
      }
      const response = await forgotPasswordService.validateOTP(email, otp);

      if (response.message) {
        toast.success("OTP Verified", { autoClose: 3000 });
        setShowPasswordForm(true);
      } else {
        toast.error(response.message, { autoClose: 3000 });
      }
    } catch (error) {
      console.error("Error validating OTP:", error);
      toast.error("An error occurred. Please try again.", { autoClose: 3000 });
    }
  };

  const handleSubmitPassword = async (e) => {
    e.preventDefault();
    console.log(password, confirmPassword);
    try {
      if (!password || !confirmPassword) {
        toast.error("Please enter password and confirm password", {
          autoClose: 3000,
        });
        return;
      } else if (password !== confirmPassword) {
        toast.error("Passwords do not match", { autoClose: 3000 });
        return;
      }
      //  else if (!isStrongPassword(confirmPassword)) {
      //   toast.error(
      //     "Password must be at least 4 characters long and contain at least one lowercase letter, one uppercase letter, one number, and one special character!",
      //     {
      //       position: "bottom-left",
      //       autoClose: 5000,
      //       hideProgressBar: false,
      //       closeOnClick: true,
      //       pauseOnHover: true,
      //       draggable: true,
      //       progress: undefined,
      //       theme: "colored",
      //     },
      //   );
      //   return;
      // }
      else {
        const response = await forgotPasswordService.createPassword(
          email,
          password,
        );
        if (response) {
          toast.success("Password confirmed successfully", { autoClose: 3000 });
          setShowPasswordForm(false);
          setShowOTPForm(false);
          navigate("/login");
        } else {
          toast.error(response.message, { autoClose: 3000 });
        }
      }
    } catch (error) {
      console.error("Error confirming password:", error);
      toast.error("An error occurred. Please try again.", { autoClose: 3000 });
    }
  };

  return (
    <form
      style={{
        display: "flex",
        position: "relative",
        flexDirection: "column",
        maxWidth: "100%",
        width: "370px",
      }}
    >
      <>
        <Box mb={4}>
          <Typography
            gutterBottom
            fontFamily={"poppins"}
            color={"#fff"}
            fontSize={18}
            fontWeight={600}
          >
            Reset Password
          </Typography>
          <InputField
            defaultIcon={
              <PermIdentityIcon sx={{ color: "#FFF" }}></PermIdentityIcon>
            }
            disable={showOTPForm || showPasswordForm}
            onChange={setEmail}
            type="text"
            placeholder="Email"
            value={email}
          />
          {showOTPForm ? (
            <>
              <Box mb={2}>
                <InputField
                  disable={showPasswordForm}
                  onChange={setOTP}
                  type="number"
                  placeholder="Enter OTP"
                  value={otp}
                  disableIcon={true}
                />
              </Box>
            </>
          ) : (
            <></>
          )}
          {showPasswordForm ? (
            <>
              <Box mb={4}>
                <InputField
                  onChange={setPassword}
                  type={isPasswordVisible ? "text" : "password"}
                  placeholder="Enter new Password"
                  value={password}
                  disableIcon={true}
                  togglePasswordVisibility={togglePasswordVisibility}
                  isPasswordVisible={isPasswordVisible}
                />
                <InputField
                  onChange={setConfirmPassword}
                  type={isConfirmPasswordVisible ? "text" : "password"}
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  disableIcon={true}
                  togglePasswordVisibility={toggleConfirmPasswordVisibility}
                  isPasswordVisible={isConfirmPasswordVisible}
                />
              </Box>
            </>
          ) : (
            <></>
          )}
        </Box>
        <Button
          onClick={(e) => {
            if (showPasswordForm) {
              handleSubmitPassword(e);
            } else if (showOTPForm) {
              handleSubmitOTP(e);
            } else {
              handleSendOTP(e);
            }
          }}
          type="submit"
          // className="justify-center items-center w-full py-3 text-lg font-semibold text-white uppercase whitespace-nowrap bg-[#FFC531] rounded-md shadow-sm"
          style={{
            backgroundColor: "#FEC50F",
            color: "#000",
            textTransform: "none",
            fontFamily: "poppins",
            fontSize: 16,
            fontWeight: 700,
          }}
        >
          {showPasswordForm
            ? "Submit"
            : showOTPForm
              ? "Submit OTP"
              : "Send OTP"}
        </Button>
      </>
    </form>
  );
}

const ForgotPassword = () => {
  const { setIsAuthenticated, setUser } = React.useContext(AppContext);
  const navigate = useNavigate();
  const { state } = useLocation();
  const isMobile = useMediaQuery("(max-width:750px)");

  React.useEffect(() => {
    if (localStorage.getItem("token")) {
      setIsAuthenticated(true);
      setUser(JSON.parse(localStorage.getItem("user")));
      navigate("/");
    }
  }, []);
  return (
    <main
      style={{
        backgroundColor: "var(--bg-paper)",
        display: "flex",
        flexDirection: "row",
      }}
    >
      {!isMobile ? (
        <div
          style={{
            backgroundColor: "var(--bg-paper)",
            display: "flex",
            flex: 1,
            height: "100vh",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              marginTop: 20,
              marginLeft: 20,
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <img
              src="/DropSkipLogo.png"
              alt="Company Logo"
              style={{
                marginBottom: 10,
                marginLeft: 20,
                aspectRatio: "2.0",
                width: "137px",
              }}
            />
            <Typography
              fontFamily={"poppins"}
              fontSize={"16px"}
              fontWeight={600}
              color={"var(--text-primary)"}
              style={{ textAlign: "center" }}
            >
              Powered by Redefined Logistics
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexGrow: 1,
            }}
          >
            <img src="/mobile.png" alt="Company Logo" />
          </div>
        </div>
      ) : (
        <></>
      )}

      <div
        style={{
          display: "flex",
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#151D48",
          height: "100vh",
          position: "relative",
        }}
      >
        {isMobile && (
          <div style={{ position: "absolute", top: 20, left: 20 }}>
            <img
              src="/DropSkipLogo.png"
              alt="Dropskip Logo"
              style={{ aspectRatio: "2.0", width: "100px" }}
            />
            <Typography
              fontFamily={"poppins"}
              fontSize={"10px"}
              fontWeight={500}
              color={"#fff"}
              style={{ marginTop: 5, textAlign: "left" }}
            >
              Powered by Redefined Logistics
            </Typography>
          </div>
        )}

        <Button
          variant="outlined"
          style={{
            backgroundColor: "#FFC531",
            color: "#000",
            textTransform: "none",
            position: "absolute",
            right: 20,
            top: 25,
          }}
          onClick={() =>
            window.open(
              "https://www.redefinedlogistics.com/contactus",
              "_blank",
            )
          }
        >
          Contact Us
        </Button>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <ForgotPasswordForm />
        </div>
      </div>
    </main>
  );
};

export default ForgotPassword;
